import React, { useState, useEffect } from 'react';

function ConfirmDialog({
  title,
  message,
  confirmText,
  cancelText,
  requiresTyping = false,
  typingConfirmation = '',
  dangerMode = false,
  icon = '❓',
  onConfirm,
  onCancel
}) {
  const [typedText, setTypedText] = useState('');
  const [isValid, setIsValid] = useState(!requiresTyping);

  useEffect(() => {
    if (requiresTyping) {
      setIsValid(typedText === typingConfirmation);
    }
  }, [typedText, typingConfirmation, requiresTyping]);

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[9999]">
      <div className={`bg-white dark:bg-charcoal-900 rounded-lg p-8 max-w-md w-[90%] shadow-2xl ${dangerMode ? 'border-2 border-red-500' : 'border border-charcoal-200 dark:border-charcoal-800'}`}>

        <div className="text-5xl text-center mb-4">{icon}</div>

        <h3 className={`text-xl font-bold text-center mb-4 ${dangerMode ? 'text-red-700 dark:text-red-500' : 'text-charcoal-900 dark:text-white'}`}>
          {title}
        </h3>

        <p className="text-sm text-charcoal-600 dark:text-charcoal-400 text-center mb-6 whitespace-pre-line">
          {message}
        </p>

        {requiresTyping && (
          <div className="mb-6">
            <input
              type="text"
              value={typedText}
              onChange={(e) => setTypedText(e.target.value)}
              placeholder={`Type "${typingConfirmation}" to confirm`}
              className="w-full p-3 border-2 border-charcoal-200 dark:border-charcoal-700 rounded-md text-sm text-center font-bold dark:bg-charcoal-800 dark:text-white focus:outline-none focus:border-blue-500"
              autoFocus
            />
          </div>
        )}

        <div className="flex gap-3 justify-center">
          <button
            className="px-6 py-3 rounded-md text-sm font-medium transition-colors bg-charcoal-100 dark:bg-charcoal-800 border border-charcoal-300 dark:border-charcoal-700 text-charcoal-700 dark:text-charcoal-300 hover:bg-charcoal-200 dark:hover:bg-charcoal-700"
            onClick={onCancel}
          >
            {cancelText}
          </button>
          <button
            className={`px-6 py-3 rounded-md text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${dangerMode ? 'bg-red-500 hover:bg-red-600 text-white border border-red-500' : 'bg-blue-500 hover:bg-blue-600 text-white border border-blue-500'}`}
            onClick={onConfirm}
            disabled={!isValid}
          >
            {confirmText}
          </button>
        </div>

      </div>
    </div>
  );
}

export default ConfirmDialog;
